
import { defineComponent } from "vue";

export default defineComponent({
  name: "PublicLayout",
  setup() {
    return {};
  }
});
